   

document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('product-popup');
  const popupContent = document.querySelector('.popup-content');
  const popupClose = document.querySelector('.popup-close');
  const popupTitle = document.getElementById('popup-title');
  const popupPrices = document.getElementById('popup-prices');
  const popupSliderWrapper = document.getElementById('popup-slider-wrapper');
  const popupAddBtn = document.getElementById('popup-add-to-cart');

  let currentVariantId = null;
  let isAvailable = false;

  function closePopup() {
    popup.style.display = 'none';
    currentVariantId = null;
    isAvailable = false;
    // allow background scrolling again if you disabled it earlier
    document.body.style.overflow = '';
  }

  // Stop clicks inside popup content from bubbling to document (prevents accidental reopen)
  popupContent.addEventListener('click', function (ev) {
    ev.stopPropagation();
  });

  // Helper: extract handle from a /products/<handle> href
  function extractHandleFromHref(href) {
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/]+)/);
      return match ? match[1] : null;
    } catch (err) {
      // fallback for relative paths not parseable by URL
      const m = href.match(/\/products\/([^/]+)/);
      return m ? m[1] : null;
    }
  }

  // Helper: get product url or handle from card element
  function resolveProductPath(card) {
    if (!card) return null;

    // 1) prefer anchor href that contains /products/
    const anchor = card.querySelector('a[href*="/products/"]');
    if (anchor && anchor.getAttribute('href')) {
      const href = anchor.getAttribute('href').split('?')[0];
      // if it's full path or handle, return /products/handle
      if (href.indexOf('/products/') !== -1) {
        // normalize to '/products/handle' (no query)
        const handle = extractHandleFromHref(href);
        if (handle) return '/products/' + handle;
        return href;
      }
    }

    // 2) try data attributes (common patterns)
    const dataHandle = card.dataset.productHandle || card.dataset.handle || card.dataset.product;
    if (dataHandle) return '/products/' + dataHandle;

    const found = card.querySelector('[data-product-handle], [data-handle], [data-product]');
    if (found) {
      const foundHandle = found.dataset.productHandle || found.dataset.handle || found.dataset.product;
      if (foundHandle) return '/products/' + foundHandle;
    }

    // 3) try to look up ANY anchor on page that points to a product inside this card
    const anyA = card.querySelector('a');
    if (anyA && anyA.getAttribute('href')) {
      const maybe = anyA.getAttribute('href').split('?')[0];
      const h = extractHandleFromHref(maybe);
      if (h) return '/products/' + h;
    }

    return null;
  }

  // Main delegated click handler for .add-btn-raj
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.add-btn-raj');
    if (!btn) return;

    // Prevent navigation (if button is inside <a>) and stop bubbling
    e.preventDefault();
    e.stopPropagation();

    // Try to find the product card container (a few common selectors)
    const cardSelectors = ['.productgrid--item', '.product-card', '.product', '.grid-item', '.swiper-slide', 'article'];
    let productCard = null;
    for (const sel of cardSelectors) {
      productCard = btn.closest(sel);
      if (productCard) break;
    }
    // If not found via common selectors, try nearest parent element
    if (!productCard) productCard = btn.closest('.product') || btn.closest('.productgrid--item') || btn.closest('li') || btn.parentElement;

    const productPath = resolveProductPath(productCard);
    if (!productPath) {
      console.error('product popup: could not resolve product path/handle for card:', productCard);
      return;
    }

    // show loading state (optional)
    popupTitle.textContent = 'Loading…';
    popupPrices.innerHTML = '';
    popupSliderWrapper.innerHTML = '';

    // fetch product JSON (Shopify supports /products/<handle>.js)
    fetch(productPath + '.js')
      .then(res => {
        if (!res.ok) throw new Error('Fetch failed: ' + res.status);
        return res.json();
      })
      .then(product => {
        // fill popup
        popupTitle.textContent = product.title || '';
        // price handling: prefer first variant price (Shopify product JSON structure may vary)
        const firstVariant = product.variants && product.variants[0] ? product.variants[0] : null;
        const comparePriceRaw = firstVariant && firstVariant.compare_at_price ? firstVariant.compare_at_price : product.compare_at_price;
        const priceRaw = firstVariant && firstVariant.price ? firstVariant.price : product.price;

        const comparePrice = comparePriceRaw ? `MRP ₹${(comparePriceRaw/100).toLocaleString()}` : '';
        const price = priceRaw ? `₹${(priceRaw/100).toLocaleString()}` : '';

        popupPrices.innerHTML = `
          ${comparePrice ? `<div class="compare">${comparePrice}</div>` : ''}
          <div class="price">${price}</div>
        `;

        // choose variant
        if (firstVariant) {
          currentVariantId = firstVariant.id;
          isAvailable = !!firstVariant.available;
        } else {
          currentVariantId = null;
          isAvailable = false;
        }

        // images
        popupSliderWrapper.innerHTML = '';
        const imgs = (product.images && product.images.length) ? product.images : (product.featured_image ? [product.featured_image] : []);
        imgs.forEach(img => {
          const wrap = document.createElement('div');
          wrap.innerHTML = `<img src="${img}" alt="${product.title || ''}">`;
          popupSliderWrapper.appendChild(wrap);
        });

        // add button state
        if (isAvailable) {
          popupAddBtn.textContent = 'ADD TO CART';
          popupAddBtn.disabled = false;
          popupAddBtn.classList.remove('soldout');
        } else {
          popupAddBtn.textContent = 'SOLD OUT';
          popupAddBtn.disabled = true;
          popupAddBtn.classList.add('soldout');
        }

        // show popup
        popup.style.display = 'block';
        // optional: prevent background scrolling while popup is open
        document.body.style.overflow = 'hidden';
      })
      .catch(err => {
        console.error('Error loading product JSON for', productPath, err);
        popupTitle.textContent = 'Unable to load product';
      });
  });

  // Add to cart
  popupAddBtn.addEventListener('click', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();

    if (!currentVariantId || !isAvailable) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json','Accept': 'application/json'},
      body: JSON.stringify({id: currentVariantId, quantity: 1})
    })
    .then(res => res.json())
    .then(data => {
      console.log('Added to cart:', data);
      closePopup();
      const cartButton = document.querySelector('.site-header-cart--button');
      if (cartButton) cartButton.click();
      else window.location.href = '/cart';
    })
    .catch(err => console.error('Add to cart error:', err));
  });

  // Close handlers
  popupClose.addEventListener('click', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    closePopup();
  });

  // clicking overlay
  popup.addEventListener('click', function (ev) {
    if (ev.target === popup) closePopup();
  });

  // escape key
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') closePopup();
  });
});





document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".site-header");

  // Case 1: By default → hideme कभी न लगे
  header.classList.remove("hideme");

  // Case 2: zoom icon click → hideme लगे
  document.addEventListener("click", function (e) {
    if (e.target.closest(".image-expand-btn")) {
      header.classList.add("hideme");
    }

    // Case 3: cross icon click → hideme हटे
    if (e.target.closest(".sg-modal-close")) {
      header.classList.remove("hideme");
    }
  });
});





document.addEventListener('DOMContentLoaded', function() {
   
setTimeout(function(){
  const tabContent = document.querySelector('.template-index .tab-section-wrapper .tab-content');
 
  if (tabContent && !tabContent.classList.contains('active')) {
    tabContent.classList.add('active');
  }
  },2500);
});

document.addEventListener('DOMContentLoaded', function() {
   
setTimeout(function(){
 const mobileTab = document.querySelector('.mobile-menu div#tab-1');
  if (mobileTab && !mobileTab.classList.contains('active')) {
    mobileTab.classList.add('active');
  }
  },2000);
});




document.addEventListener('DOMContentLoaded', function() {
  const sortSelect = document.querySelector('[data-productgrid-trigger-sort]');
  if (!sortSelect) return;

  const urlParams = new URLSearchParams(window.location.search);
  const currentSort = urlParams.get('sort_by');

  let defaultSort = currentSort || sortSelect.querySelector('option[selected]')?.value || 'best-selling';

  sortSelect.addEventListener('change', function(e) {
    const selectedValue = e.target.value;
    const currentUrl = new URL(window.location.href);

    if (selectedValue === defaultSort) {
      currentUrl.searchParams.delete('sort_by');
    } else {
      currentUrl.searchParams.set('sort_by', selectedValue);
    }

    window.location.href = currentUrl.toString();
  });
});



// if (window.innerWidth <= 767) {

//     document.addEventListener("DOMContentLoaded", function () {
//     if (!window.jQuery) return;

//     var $slider = $('.product-gallery--viewer');

//     /* 🔴 If already slick → destroy */
//     if ($slider.hasClass('slick-initialized')) {
//         $slider.slick('unslick');
//     }

//     /* 🟢 Re-init WITH dots */
//     $slider.slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: true,
//         dots: true,              // ✅ dots enabled
//         infinite: false,
//         adaptiveHeight: true,
//         fade: true,
//         speed: 500,

//         prevArrow: `
//         <button class="carousel-btn prev slick-arrow" type="button">
//             ❮
//         </button>`,

//         nextArrow: `
//         <button class="carousel-btn next slick-arrow" type="button">
//             ❯
//         </button>`,

//         customPaging: function () {
//         return '<button class="slick-dot"></button>';
//         }
//     });
//     });

// } else {
//   // 💻 Desktop JS
// }



document.addEventListener("DOMContentLoaded", function () {
  if (!window.jQuery) return;

  const $thumbSlider = jQuery('[data-gallery-scroller]');

  if ($thumbSlider.hasClass('slick-initialized')) {
    $thumbSlider.slick('unslick');
  }

  $thumbSlider.slick({
    infinite: true,              // 🔁 repeat images
    slidesToShow: 7,             // ✅ 10 thumbnails
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    centerMode: false,
    variableWidth: false,
    swipeToSlide: true,
    touchMove: true,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7
        }
      },
      {
        breakpoint: 768,          // 📱 MOBILE
        settings: {
          slidesToShow: 7,       // ✅ mobile me bhi 10
          infinite: true
        }
      }
    ]
  });
});


(function () {

  if (!window.jQuery) return;
  if (window.__product_gallery_sync__) return;
  window.__product_gallery_sync__ = true;

  const $mainSlider  = jQuery('[data-gallery-viewer]');
  const $thumbSlider = jQuery('[data-gallery-scroller]');

  if (!$mainSlider.length || !$thumbSlider.length) return;

  /* ===============================
     1️⃣ THUMB → MAIN SLIDER SYNC
  =============================== */
  document.body.addEventListener('click', function (e) {
    const thumbBtn = e.target.closest('[data-gallery-thumbnail]');
    if (!thumbBtn) return;

    e.preventDefault();

    const index = parseInt(thumbBtn.getAttribute('data-gallery-index'), 10);
    if (isNaN(index)) return;

    if ($mainSlider.hasClass('slick-initialized')) {
      $mainSlider.slick('slickGoTo', index, true);
    }

    // Active state
    document.querySelectorAll('[data-gallery-thumbnail]').forEach(btn => {
      btn.setAttribute('data-gallery-selected', 'false');
    });
    thumbBtn.setAttribute('data-gallery-selected', 'true');
  }, true);

  /* ===============================
     2️⃣ MAIN → THUMB AUTO SYNC
  =============================== */
  $mainSlider.on('afterChange', function (event, slick, currentSlide) {
    document.querySelectorAll('[data-gallery-thumbnail]').forEach(btn => {
      const idx = parseInt(btn.getAttribute('data-gallery-index'), 10);
      btn.setAttribute(
        'data-gallery-selected',
        idx === currentSlide ? 'true' : 'false'
      );
    });

    // auto scroll thumbnail into view
    const activeThumb = document.querySelector(
      '[data-gallery-thumbnail][data-gallery-index="' + currentSlide + '"]'
    );
    if (activeThumb && activeThumb.scrollIntoView) {
      activeThumb.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  });

  /* ===============================
     3️⃣ FIX CLONE INDEX ISSUE
  =============================== */
  function normalizeThumbIndexes() {
    const thumbs = document.querySelectorAll('[data-gallery-thumbnail]');
    thumbs.forEach((btn, i) => {
      btn.setAttribute('data-gallery-index', i);
    });
  }

  normalizeThumbIndexes();

  /* ===============================
     4️⃣ SAFETY: RE-RUN AFTER SLICK REFRESH
  =============================== */
  $thumbSlider.on('init reInit afterChange', function () {
    normalizeThumbIndexes();
  });

})();



